import { render, staticRenderFns } from "./OtherStat.vue?vue&type=template&id=57c249ce&scoped=true"
import script from "./OtherStat.vue?vue&type=script&lang=js"
export * from "./OtherStat.vue?vue&type=script&lang=js"
import style0 from "./OtherStat.vue?vue&type=style&index=0&id=57c249ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c249ce",
  null
  
)

export default component.exports